export default "__VITE_ASSET__Cq6_FBDW__"